var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppsFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.803,
    height: 70.803,
    viewBox: "0 0 70.803 70.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h70.8v70.8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.8h11.8V4H4zm17.7 35.4h11.8V39.4H21.7zM4 51.2h11.8V39.4H4zm0-17.7h11.8V21.7H4zm17.7 0h11.8V21.7H21.7zM39.4 4v11.8h11.8V4zM21.7 15.8h11.8V4H21.7zm17.7 17.7h11.8V21.7H39.4zm0 17.7h11.8V39.4H39.4z",
    transform: "translate(7.8 7.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsFilled);
export default __webpack_public_path__ + "static/media/apps-filled.24afd7576dff580f75bd9d386e666dca.svg";
export { ForwardRef as ReactComponent };